import { Pipe, PipeTransform } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { MaintenanceProductService } from '@interfaces';
import { TranslateService } from '@ngx-translate/core';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Pipe({
  name: 'getValueService'
})
export class GetValueService implements PipeTransform {
  public constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly translateService: TranslateService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  transform(
    orderProductService: MaintenanceProductService,
    companyId?: string
  ): { label: string; tooltip: string } {

    const productServiceCompany =
      orderProductService.item.productServiceCompanies.find(
        (psc) => psc.company.id === companyId
      );

    const isCustom = !!(productServiceCompany.preferences && productServiceCompany.preferences.weekDayValues);

    if (isCustom) {
      return {
        tooltip: this.translateService.instant(
          'CUSTOM_VALUE.TOOLTIP'
        ),
        label: this.translateService.instant(
          'CUSTOM_VALUE.LABEL'
        )
      };
    }

    return {
      tooltip: null,
      label: `R$${new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2
      }).format(orderProductService.value || 0)}`
    };
  }
}
